import { types, getSnapshot } from 'mobx-state-tree';
import QCard from './QCard';

const QList = types
  .model('QList', {
    completedDiscoveries: types.optional(types.array(QCard), []),
    discoveriesInProgress: types.optional(types.array(QCard), []),
    failedDiscoveries: types.optional(types.array(QCard), []),
    listedDiscoveries: types.optional(types.array(QCard), []),
  })
  .actions(self => ({
    updateDiscoveryRecord(id, items) {
      const record = self.discoveriesInProgress.find(el => el.id === id);
      if (record) {
        record.setItems(items);
      } else {
        console.error('qCard not found');
      }
    },
    spliceList(listName, id) {
      for (let i = 0; i < self[listName].length; i++) {
        if (self[listName][i].id === id) {
          const r = getSnapshot(self[listName][i]);
          self[listName].splice(i, 1);
          return r;
        }
      }
      return null;
    },
    addToList(listName, item, statusId, processedItemsCount) {
      const newCard = QCard.create(item);
      newCard.setItems(processedItemsCount);
      if (!self[listName]) {
        self[listName] = [newCard];
        return;
      }
      for (let i = 0; i < self[listName].length; i++) {
        if (self[listName][i].id < item.id) {
          // item.setStatusId(statusId);
          self[listName].splice(i, 0, newCard);
          return;
        }
      }
    },
  }));

export default QList;
